<section class="solutions" id="solutions">
  <div class="container">
    <div class="solutions__header">
      <span class="section-tag">{{ t().sol_tag }}</span>
      <h2 class="section-title">{{ t().sol_title }}<br><span>{{ t().sol_title_suffix }}</span></h2>
      <p class="section-subtitle">{{ t().sol_subtitle }}</p>
    </div>

    <div class="solutions__grid">
      @for (sol of cards(); track sol.title; let i = $index) {
        <div class="solution-card" [style.--card-color]="sol.color" [style.animation-delay]="(i * 0.12) + 's'">
          <div class="card-icon">
            @if (sol.icon === 'shield') {
              <svg viewBox="0 0 24 24" fill="none"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>
            }
            @if (sol.icon === 'hard-hat') {
              <svg viewBox="0 0 24 24" fill="none"><path d="M2 18h20M12 2C8 2 4 5 4 9v3h16V9c0-4-4-7-8-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><rect x="1" y="18" width="22" height="3" rx="1.5" stroke="currentColor" stroke-width="2"/></svg>
            }
            @if (sol.icon === 'leaf') {
              <svg viewBox="0 0 24 24" fill="none"><path d="M17 8C8 10 5.9 16.17 3.82 19.5M21 3C11 5 8 13 7 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            }
            @if (sol.icon === 'chart') {
              <svg viewBox="0 0 24 24" fill="none"><path d="M18 20V10M12 20V4M6 20v-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            }
          </div>

          <h3 class="card-title">{{ sol.title }}</h3>
          <p class="card-desc">{{ sol.desc }}</p>

          <ul class="card-features">
            @for (feat of sol.features; track feat) {
              <li>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <circle cx="7" cy="7" r="7" fill="var(--card-color)" opacity="0.15"/>
                  <path d="M4 7l2 2 4-4" stroke="var(--card-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{ feat }}
              </li>
            }
          </ul>

          <a href="#contact" class="card-link">
            {{ t().sol_learn_more }}
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      }
    </div>
  </div>
</section>
